import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("oc_admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 401 on admin endpoints → wipe token + redirect to login (prevents unhandled
// axios rejections from showing the CRA dev error overlay)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && url.includes("/admin")) {
      localStorage.removeItem("oc_admin_token");
      localStorage.removeItem("oc_admin_email");
      if (typeof window !== "undefined" && !window.location.pathname.endsWith("/admin/login")) {
        window.location.replace("/admin/login");
      }
    }
    return Promise.reject(error);
  }
);

export default api;
